// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"756":"e157a408","842":"4eeb740d"}[chunkId] + ".chunk.js";
};